const FORM = {
    onReady() {
        FORM.option();
        FORM.checbox();
        FORM.fillSource();
    },
    readOnly(that) {
        if (that.hasAttribute('readonly')) {
            that.removeAttribute('readonly');
            // fix for mobile safari to show virtual keyboard
            that.blur();
            that.focus();
        }
    },
    fillSource() {
        let sources = document.querySelectorAll('input[type="hidden"][name="source"]');
        sources.forEach(source => {
            if (source.value !== "") return;
            source.value = window.location.href;
        });
    },
    /*********************
    * Option Toggler
    *********************/
    option() {
        let options = document.querySelectorAll('.js-radio');
        options.forEach(option => {
            option.addEventListener('click', () => {
                let group         = option.name;
                let groupedRadios = document.querySelectorAll(`input[type=radio][name="${group}"]`);
                groupedRadios.forEach(groupedRadio => {
                    groupedRadio.parentNode.classList.remove('checked');
                });
                option.parentNode.classList.add('checked');
            });
        });
    },
    /*********************
    * Checkboxes Toggler
    *********************/
    checbox() {
        let options = document.querySelectorAll('.js-checkbox');
        options.forEach(option => {
            option.addEventListener('click', () => {
                option.parentNode.classList.toggle('checked');
            });
        });
    },
    /*********************
    * Form validation
    *********************/
    validate(that = null, event) {
        (that !== null) && (that.disabled = true);
        event.preventDefault();
        OVERLAY.loading();
        let form  = that.closest('form');
        let email = form.querySelector('input[type="email"]');
        let phone = form.querySelector('input[type="tel"]');
        
        // reset the form
        let inputs    = form.getElementsByTagName('input');
        let textareas = form.getElementsByTagName('textarea');
        let labels    = form.getElementsByTagName('label');
        for (i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove('error');
        }
        for (j = 0; j < textareas.length; j++) {
            textareas[j].classList.remove('error');
        }
        for (k = 0; k < labels.length; k++) {
            labels[k].classList.remove('error');
        }
        var error = 0;
        //check required
        for (i = 0; i < inputs.length; i++) {
            var parent = inputs[i].parentNode;
            if (inputs[i].required && inputs[i].value === '' && !parent.classList.contains('is-hidden')) {
                inputs[i].classList.add('error');
                error++
            } else if (inputs[i].required && inputs[i].type === 'radio') {
                let radios = document.querySelectorAll('input[name="'+ inputs[i].name +'"]:checked');
                if (radios.length < 1) {
                    inputs[i].classList.add('error');
                    error++;
                }
            } else if (inputs[i].required && inputs[i].type === 'checkbox') {
                let checkboxes = document.querySelectorAll('input[data-checkbox-group="'+ inputs[i].dataset.checkboxGroup +'"]:checked');
                if (checkboxes.length < 1) {
                    inputs[i].classList.add('error');
                    parent.classList.add('error');
                    error++;
                }
            }
        }
        for (j = 0; j < textareas.length; j++) {
            if (textareas[j].required && textareas[j].value === '') {
                textareas[j].classList.add('error');
                error++;
            }
        }
        //check email format
        if ( email !== null ) {
            var regex_email = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (regex_email.test( email.value ) === false && email.required) {
                email.classList.add('error');
                error++;
            }
        }
        // check phone format + length
        if ( phone !== null ) {
            var regex_phone = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
            if (phone.value !== '' && phone.required === false) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            } else if (phone.required) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            }
        }
        // proceed or return
        if (error > 0) {
            document.getElementById('overlay-loading').remove();
            form.classList.add('error');
            (that !== null) && (that.disabled = false);
            return;
        } else {
            let submitButton = form.querySelector('button');
            (submitButton !== null) && (submitButton.disabled = true);
            form.classList.remove('error');
            FORM.sendData(form);
        }
    },
    /*********************
    * Show the response
    *********************/
    response(form, node) {
        (form.previousElementSibling !== null) && form.previousElementSibling.remove(); // form head text
        (form.nextElementSibling !== null) && form.nextElementSibling.remove(); // data privacy disclaimer
        // form.insertAdjacentHTML('afterend', markup);
        form.parentNode.insertBefore(node, form.nextSibling);
        form.remove();
    },
    /*********************
    * Store Data
    *********************/
    storeData(form) {
        let rememberInputs = form.querySelectorAll('.remember');
        let rememberValues = [];
        rememberInputs.forEach(input => {
            let key     = input.classList.contains('form__choice__input') ? input.name : input.id;
            let value   = input.value;
            let element = {};
            element[key] = value;
            (input.classList.contains('form__choice__input') && input.checked) && rememberValues.push(element);
            (input.classList.contains('form__choice__input') === false) && rememberValues.push(element);
        });
        let rememberValuesStr = encodeURIComponent(JSON.stringify(rememberValues));
        COOKIE.set({
            name: 'stored_form_input', 
            value: rememberValuesStr, 
            days: 365
        });
    },
    /*********************
    * Sends the data over a XHR request
    *********************/
    sendData(form) {
        if (form.classList.contains('store')) {
            FORM.storeData(form);
        }
        if (typeof form.dataset.redirect != 'undefined') {
            window.location = form.dataset.redirect;
        }
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = FORM.serialize(form) + '&nonce=' + encodeURIComponent(ieNonce);
        // console.log(formData);
        let handler  = 'handler.XHR.php?handler=' + form.dataset.handler;
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var responseNode = form.querySelector('.form__responses [data-response="' + xhr.response + '"]').content.cloneNode(true);
                } else {
                    var responseNode = form.querySelector('.form__responses [data-response="error"]').content.cloneNode(true);
                }
                FORM.response(form, responseNode);
                document.getElementById('overlay-loading').remove();
            }
        };
        xhr.onerror = (e) => {
            var responseNode = form.querySelector('.form__responses [data-response="error"]').content.cloneNode(true);
            FORM.response(form, responseNode);
            document.getElementById('overlay-loading').remove();
        };
        xhr.send(formData);
        console.log(xhr);
    },
    /*********************
    * Input serialiser 
    *********************/
    serialize(form) {
        var serialized = [];
        for (var i = 0; i < form.elements.length; i++) {
            var field = form.elements[i];
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value));
                }
            } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
            }
        }
        return serialized.join('&');
    }
}